
export class AdditionalInformationPagarMe {
    name: string;
    value: string;    

	constructor() {
	
	}
}